export const dtoState = {
    NewModified: 'NEWMODIFIED',
    New: 'NEW',
    Updated: 'UPDATED',
    Deleted: 'DELETED',
    Unset: 'UNSET'
};
